// column header for event Attendees => who is coming
export const whoIsComingConstants = {
    columns: [
        {
            text: 'Name',
            align: 'left',
            sortable: true,
            value: 'displayName',
        },
        {
            text: 'Primary Chapter',
            value: 'primaryChapterName',
            sortable: true,
        },
        {
            text: 'Primary Region',
            value: 'primaryRegionName',
            sortable: true,
        },
        {
            text: 'Company',
            value: 'companyName',
            sortable: true,
        },
    ],
    TITLE: 'Who\'s Coming',
    SEARCH_ATTENDEES: 'Search Attendees',

};

export const noResultFound = searchText => ` Your search for "${searchText}" found no results.`;

